import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class SiteLogoRestConnectorService extends RestConnectorService {
  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>) {
    super(_store);
  }
  //// Site Logo ////

  public loadSiteLogo(): Observable<string> {
    return this._httpClient.get<string>(
      '/api/images/logo/',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<string>) => httpResponse.body),
    );
  }

  public deleteSiteLogo(): Observable<any> {
    return this._httpClient.delete(
      '/api/images/logo/',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<any>) => httpResponse.body),
    );
  }
}
